// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yyj5","label":"CategoryService_label__2-XEy","location":"CategoryService_location__1xFi3"};